import { createService } from "services/serviceFactory";
import { headers } from "../headers";
import { CreateModuleUsageLogRequest, UserActivityRequest } from "./request";
import { ModuleUsageDashboardResponseView } from "services/account";

const loggerService = createService("logger");

async function fetchUserActivity(data: UserActivityRequest, accessToken: string) {
    return loggerService.post("/logger/v1/Logger/GetUserActivityLogList", data, {
        headers: {
            ...headers,
            Authorization: `Bearer ${accessToken}`,
        },
    });
}

async function createModuleUsageLog(data: CreateModuleUsageLogRequest, accessToken: string) {
    return loggerService.post("/logger/v1/Logger/CreateModuleUsageLog", data, {
        headers: {
            ...headers,
            Authorization: `Bearer ${accessToken}`,
        },
    });
}

async function getModuleUsageDashboardData(
    accessToken: string
) {
    return loggerService.post<ModuleUsageDashboardResponseView>(
        "/logger/v1/Logger/GetModuleUsageDashboardData",
        {},
        {
            headers: {
                ...headers,
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
}

export { fetchUserActivity, createModuleUsageLog, getModuleUsageDashboardData };
